import Vue from 'vue'
import Vuex from 'vuex'
import VueYoutube from 'vue-youtube'
import pathify from '@/plugins/vuex-pathify'
import auth from './auth'
import ui from './ui'
import home from './home'
import loader from './loader'
import enrollment from './enrollment'
import tryout from './tryout'
import groupjoin from './groupjoin'
import explanation from './explanation'
import questionbank from './questionbank'
import flash from './flash'
import createtryout from './createtryout'

Vue.use(Vuex)
Vue.use(VueYoutube)

export default new Vuex.Store({
    plugins: [ pathify.plugin ],
    state: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        auth,
        ui,
        home,
        loader,
        enrollment,
        tryout,
        groupjoin,
        explanation,
        questionbank,
        flash,
        createtryout,
    }
})
